// src/components/pages/admin-dash/DrawCreate.jsx
import React, { useState } from "react";
import axiosInstance from "../../../utils/AxiosInstance";
import DrawForm from "./DrawForm";

/**
 * Create draw form — used to manually add a draw record when the
 * automated feed misses one or to backfill history.
 *
 * POST /admin/draw, body shape = DrawRequestDto (see DrawForm.jsx for
 * why this no longer sends drawNumber/isAccumulated/winningNumbers[]).
 *
 * Props:
 *   onShowToast(message, tone)
 *   onCreated(draw)   optional callback after success
 */
export default function DrawCreate({ onShowToast, onCreated }) {
  const [submitting, setSubmitting] = useState(false);
  const [formKey, setFormKey] = useState(0); // bump to reset DrawForm after a successful create

  const handleSubmit = async (body) => {
    setSubmitting(true);
    try {
      const res = await axiosInstance.post("/admin/draw", body);
      onShowToast?.(`Draw #${res?.data?.id ?? ""} created.`, "success");
      onCreated?.(res?.data);
      setFormKey((k) => k + 1);
    } catch (err) {
      onShowToast?.(
        err?.response?.data?.message || err?.response?.data?.violations?.[0] || "Failed to create draw.",
        "error"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-4 max-w-3xl">
      <header>
        <h1 className="font-semibold mb-1" style={{ fontSize: 22, color: "var(--txt)" }}>
          Create draw
        </h1>
        <p className="text-[12px]" style={{ color: "var(--txt-2)" }}>
          Manually add a draw entry. Use this only when the automated feed
          misses a draw or for backfilling history.
        </p>
      </header>

      <DrawForm key={formKey} submitLabel="Create draw" submitting={submitting} onSubmit={handleSubmit} />
    </div>
  );
}
